const Customer = {
  queryList: [
    {
      name: 'name',
      label: '客服姓名',
      component: 'input'
    },
    {
      name: 'username',
      label: '客服账号',
      component: 'input'
    },
    {
      name: 'schoolName',
      label: '单位名称',
      component: 'input'
    }
  ],
  urlMap: {
    select: '/custom/customPermission/customList',
    update: '/school/schoolDegreeOffice/saveOrUpdate',
    delete: '/school/schoolDegreeOffice/delete/{id}'
  },
  operList: [// 操作列表
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        addr: 'systemManage/employerEdit'
      }
    }
  ],
  titles: [
    {
      name: 'name',
      label: '客服姓名'
    },
    {
      name: 'username',
      label: '客服账号'
    },
    // {
    //   name: 'schoolName',
    //   label: '单位名称'
    // },
    {
      name: 'mobile',
      label: '联系电话'
    },
    {
      name: 'email',
      label: '邮箱'
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '分配送审批单位',
          name: 'patchUnit',
          width: 800,
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          addr: 'systemManage/patchUnit?{userId}'
        }
      ]
    }
  ]
}
export default Customer



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/systemManage/customer.js